/* eslint-disable jsx-a11y/anchor-is-valid */
import {Button} from 'primereact/button'
import {Checkbox} from 'primereact/checkbox'
import {InputMask} from 'primereact/inputmask'
import {InputText} from 'primereact/inputtext'
import {useEffect, useMemo, useRef, useState} from 'react'
import {withRouter} from 'react-router-dom'
import Turnstile, {useTurnstile} from 'react-turnstile'
import {HTTP_STATUS_OK, SystemRole, TURNSTILE} from '../../Constants'
import mailBoxImg from '../../assets/images/ MailBox.svg'
import changePasswordImg from '../../assets/images/ChangePassword.svg'
import forgotPasswordImg from '../../assets/images/FogotPasswordImg.svg'
import logo from '../../assets/images/SafeStep.svg'
import successImg from '../../assets/images/SuccessImg.svg'
import loginPageImg from '../../assets/images/loginPageImg.svg'
import {getLanguageCode} from '../../i18n/LanguageUtils'
import TranslateUtils from '../../i18n/TranslateUtils'
import {lowerCase} from '../../utils/CommonUtils'
import {openPage} from '../../utils/NavigatorUtils'
import {component} from '../form/Constant'
import {severityNotification} from '../notification/NotificationConstant'
import {showNotification} from '../notification/NotificationService'
import {convertKeyToLabel} from '../table-utils/TableUtils'
import {
    authenticateUser,
    changePassword,
    checkVerificationCode,
    checkVerificationCodeAsPassword,
    sendVerificationCode,
    validateCloudFlareCaptcha,
} from './AuthEndPoints'
import {shouldStoreRefreshToken, storeAllUserData} from './AuthUtils'
import './Authentication.css'
import BackgroundImage from './auth_background_2.png'
const activePageTypes = {
    login: 'Login',
    forgetPassword: 'Forget Password',
    verificationCode: 'Verification',
}

// const buttonClassName =
//     'col-12 p-button-lg bg-blue-800 border-none font-semibold '

const loginKeys = {
    username: 'username',
    password: 'password',
    verificationCode: 'verificationCode',
    usernameOrEmail: 'usernameOrEmail',
    newPassword: 'newPassword',
    retypePassword: 'retypePassword',
    resendVerificationTimer: 'resendVerificationTimer',
}

const Authentication = ({type}) => {
    const initialData = {
        username: '',
        password: '',
        verificationCode: '',
        usernameOrEmail: '',
        newPassword: '',
        retypePassword: '',
    }
    const [account, setAccount] = useState({...initialData})
    const [activeIndex, setActiveIndex] = useState(0)
    const [activePage, setActivePage] = useState(activePageTypes.login)
    const [isRemembered, setIsRemembered] = useState(false)
    const {translateCommons, translateKeys} = TranslateUtils()
    const focusRef = useRef([])
    const [focusedIndex, setFocusedIndex] = useState(0)

    const handleRememberUser = () => {
        setIsRemembered(!isRemembered)
        shouldStoreRefreshToken(!isRemembered)
    }

    const normalizeUsername = username => {
        return username.replace(/\s/g, '')
    }

    const handleSignInKeyPress = (e, idx) => {
        if (e.key === 'Enter') {
            if (idx === 1) {
                if (activePage === activePageTypes.login) {
                    if (!isHuman) {
                        return
                    }
                    handleSignIn()
                }
            } else {
                focusRef.current[idx + 1].focus()
                setFocusedIndex(idx + 1)
            }
        }
    }
    const toNextStep = () => {
        setActiveIndex(prevState => (prevState < 3 ? prevState + 1 : 3))
    }

    const toPrevStep = () => {
        setActiveIndex(prevState => (prevState > 0 ? prevState - 1 : 0))

        setAccount({
            ...account,
            usernameOrEmail: '',
            verificationCode: '',
        })
    }

    const handleSendVerificationCode = async () => {
        const sentStatus = await sendVerificationCode({
            usernameOrEmail: account.usernameOrEmail,
        })
        if (sentStatus === HTTP_STATUS_OK) {
            showNotification(
                severityNotification.success,
                'Verification code has been sent',
            )
            toNextStep()
        } else {
            if (window?.grecaptcha) {
                window?.grecaptcha.reset()
            }
        }
    }

    const handleCheckVerificationCode = async () => {
        const verificationStatus = await checkVerificationCode({
            usernameOrEmail: account.usernameOrEmail,
            verificationCode: account.verificationCode
                .replace(/[^a-zA-Z0-9]/g, '')
                .toUpperCase(),
        })
        if (verificationStatus === HTTP_STATUS_OK) {
            toNextStep()
        }
    }

    const handleChangePassword = async () => {
        const changedStatus = await changePassword({
            usernameOrEmail: account.usernameOrEmail,
            newPassword: account.newPassword,
            retypePassword: account.retypePassword,
        })
        if (changedStatus === HTTP_STATUS_OK) {
            showNotification(
                severityNotification.success,
                'Password has been changed',
            )

            setAccount({})
            toNextStep()
        }
    }

    const onSubmit = async () => {
        if (activePage === activePageTypes.forgetPassword) {
            // eslint-disable-next-line default-case
            switch (activeIndex) {
                case 0:
                    if (!account.usernameOrEmail) {
                        showNotification(
                            severityNotification.info,
                            'Missing username or email',
                        )

                        return
                    }

                    await handleSendVerificationCode()
                    break
                case 1:
                    if (!account.verificationCode) {
                        showNotification(
                            severityNotification.info,
                            'Verification code is required !',
                        )
                        return
                    }

                    await handleCheckVerificationCode()
                    break
                case 2:
                    if (!account.newPassword) {
                        showNotification(
                            severityNotification.info,
                            'Missing new password',
                        )
                        return
                    }

                    if (!account.retypePassword) {
                        showNotification(
                            severityNotification.info,
                            'Missing retype password',
                        )
                        return
                    }

                    if (account.newPassword !== account.retypePassword) {
                        showNotification(
                            severityNotification.info,
                            'New password and retype password not match',
                        )
                        return
                    }

                    await handleChangePassword()
                    break
                case 3:
                    handleBackToLogin()
                    break
            }
        }
        if (activePage === activePageTypes.verificationCode) {
            let toPostData = {
                username: account?.username,
                verificationCode: account?.verificationCode
                    .replace(/[^a-zA-Z0-9]/g, '')
                    .toUpperCase(),
            }
            const response = await checkVerificationCodeAsPassword(toPostData)
            if (!!response && response?.userInfo && response?.userToken) {
                storeAllUserData(response)
                showNotification(severityNotification.success, 'Success')
                openPage('/')
            }
        }
    }

    const handleBackToLogin = () => {
        setActivePage(activePageTypes.login)
        setActiveIndex(0)
        setAccount({})
        setCountDownToLogin(10)
    }

    const [countDownToLogin, setCountDownToLogin] = useState(10)
    useEffect(() => {
        if (activeIndex === 3) {
            if (countDownToLogin === 0) {
                handleBackToLogin()

                return
            }

            const countDownInterval = setInterval(() => {
                setCountDownToLogin(prevState =>
                    prevState > 0 ? prevState - 1 : 0,
                )
            }, 1000)

            return () => clearInterval(countDownInterval)
        }
    }, [countDownToLogin, activeIndex])

    const [resendVerificationTimer, setResendVerificationTimer] = useState(120)
    useEffect(() => {
        if (activeIndex === 1) {
            const resendVerificationInterval = setInterval(() => {
                setResendVerificationTimer(prevState =>
                    prevState > 0 ? prevState - 1 : 0,
                )
            }, 1000)

            return () => clearInterval(resendVerificationInterval)
        }
    }, [resendVerificationTimer, activeIndex])

    const handleResendVerificationCode = async () => {
        const sentStatus = await sendVerificationCode({
            usernameOrEmail: account.usernameOrEmail,
        })
        if (sentStatus === HTTP_STATUS_OK) {
            showNotification(
                severityNotification.success,
                'Verification code has been re-sent',
            )

            setResendVerificationTimer(120)
        }
    }
    // #endregion

    //#region Authentication
    const handleSignIn = async () => {
        if (!account?.username) {
            showNotification(severityNotification.info, 'Missing username')
            return
        }

        if (!account?.password) {
            showNotification(severityNotification.info, 'Missing password')
            return
        }

        const toPostData = {
            username: account?.username,
            password: account?.password,
        }

        await authenticateUser(toPostData)
            .then(async data => {
                if (!!data && data?.userInfo && data?.userToken) {
                    if (
                        data?.userInfo &&
                        data?.userInfo?.systemRole === SystemRole.USER &&
                        (!data?.accessConfig ||
                            (data?.accessConfig &&
                                !data?.accessConfig?.allowToAccessPatientPage))
                    ) {
                        showNotification(
                            severityNotification.info,
                            'Access to your account is not permitted.',
                        )
                        return
                    }
                    storeAllUserData(data)

                    localStorage.setItem('showLoading', true)

                    openPage('/')
                } else {
                    setAccount({
                        ...account,
                        password: '',
                    })
                }
            })
            .catch(err => {
                if (err?.response?.status === 409) {
                    setActivePage(activePageTypes.verificationCode)
                }
            })
    }
    //#endregion

    const pageInfo = useMemo(() => {
        switch (activePage) {
            case activePageTypes.login:
                return {
                    title: 'Login',
                    subtitle:
                        'Please enter your username and password to log in.',
                    img: loginPageImg,
                }
            case activePageTypes.forgetPassword:
                return {
                    title: 'Forget Password',
                    subtitle:
                        activeIndex === 0
                            ? 'Please enter your username or email address. You will receive a link to create a new password via email.'
                            : activeIndex === 1
                            ? 'Please check your email for a verification code. If it doesn’t appear within a few minutes, check your spam folder.'
                            : activeIndex === 2
                            ? 'Feel free to change your new password as you wish.'
                            : 'Your password has been changed. Please use your new password for further authentication.',
                    img:
                        activeIndex === 0
                            ? forgotPasswordImg
                            : activeIndex === 1
                            ? mailBoxImg
                            : activeIndex === 2
                            ? changePasswordImg
                            : successImg,
                }
            case activePageTypes.verificationCode:
                return {
                    title: 'Verification Code',
                    subtitle:
                        'Please check your email for the verification code.',
                    img: mailBoxImg,
                }
            default:
                return {
                    title: 'Login',
                    subtitle:
                        'Please enter your username and password to log in.',
                    img: loginPageImg,
                }
        }
    }, [activeIndex, activePage])

    const inputTextClassName =
        'p-inputtext-lg block col-12 mb-2 placeholder-text-color input-login'
    const loginForm = useMemo(() => {
        let listForm = [
            {
                key: activePageTypes.login,
                items: [
                    {
                        key: loginKeys.username,
                        component: component.inputText,
                        isLowerCase: true,
                        placeholder: 'Input your username or email',
                    },
                    {
                        key: loginKeys.password,
                        component: component.inputText,
                        type: 'password',
                        placeholder: 'Input your password',
                    },
                    {key: 'rememberGr', component: component.checkBoxGroup},
                ],
            },
            {
                key: activePageTypes.forgetPassword,
                items: [
                    {
                        key: loginKeys.usernameOrEmail,
                        activeIndex: 0,
                        component: component.inputText,
                        isLowerCase: true,
                        placeholder: 'Input your username or email',
                    },
                    {
                        key: loginKeys.verificationCode,
                        activeIndex: 1,
                        component: component.inputMask,
                        isLowerCase: true,
                    },
                    {
                        key: loginKeys.resendVerificationTimer,
                        activeIndex: 1,
                        component: 'resendVerificationTimer',
                    },
                    {
                        key: loginKeys.newPassword,
                        activeIndex: 2,
                        component: component.inputText,
                        placeholder: 'Enter a new password',
                        type: 'password',
                    },
                    {
                        key: loginKeys.retypePassword,
                        label: 'Re-type Password',
                        activeIndex: 2,
                        component: component.inputText,
                        placeholder: 'Re-enter password',
                        type: 'password',
                    },
                    {
                        key: 'success',
                        activeIndex: 3,
                    },
                ],
            },
            {
                key: activePageTypes.verificationCode,
                items: [
                    {
                        key: loginKeys.verificationCode,
                        activeIndex: 0,
                        component: component.inputMask,
                        isLowerCase: true,
                    },
                ],
            },
        ]

        return listForm
    }, [])

    //#region Cloudflare Turnstile
    const turnstile = useTurnstile()
    const turnstileRef = useRef(null)

    const resetTurnstile = () => {
        turnstile.reset(turnstileRef.current)
    }

    const [isHuman, setIsHuman] = useState(true)
    //#endregion

    return (
        <div
            className="flex  align-items-center justify-content-center auth-bg-wrapper relative font-family-poppins relative"
            style={{backgroundImage: `url(${BackgroundImage})`}}>
            <div className="flex auth-form-wrapper p-2 px-4  md:px-6 md:px-0">
                <div className="col-12 flex flex-column gap-5 glassmorphism-login my-1  px-3 md:px-6 py-4 ">
                    <div className="flex flex-column gap-3 flex-grow-1">
                        <div className="flex gap-1">
                            <div>
                                <img className="auth-tavie-logo" src={logo} />
                            </div>
                            <h2 className="font-bold">SafeStep</h2>
                        </div>
                        <div className=" flex flex-column  gap-3 text-center ">
                            <div className="flex justify-content-center ">
                                <img
                                    className=""
                                    src={pageInfo.img}
                                    style={{height: '20rem'}}
                                />
                            </div>
                            <h1 className=" font-semibold text-teal-700 mb-0">
                                {translateCommons(pageInfo.title).toUpperCase()}
                            </h1>{' '}
                            <h5 className="text-xl  lg:text-2xl my-1">
                                {translateCommons(pageInfo.subtitle)}
                            </h5>
                        </div>

                        <div className="flex flex-column justify-content-center">
                            {loginForm.map(
                                item =>
                                    item.key === activePage && (
                                        <div
                                            key={item.key}
                                            className="flex flex-column gap-3">
                                            {item.items.map(
                                                (childrenItem, idx) =>
                                                    (item.key !==
                                                        activePageTypes.forgetPassword ||
                                                        (item.key ===
                                                            activePageTypes.forgetPassword &&
                                                            childrenItem.activeIndex ===
                                                                activeIndex)) && (
                                                        <div
                                                            key={idx}
                                                            className="">
                                                            {childrenItem.component ===
                                                            component.inputText ? (
                                                                <>
                                                                    <h5 className="my-2 text-700 font-semibold">
                                                                        {translateCommons(
                                                                            childrenItem.label ??
                                                                                convertKeyToLabel(
                                                                                    childrenItem.key,
                                                                                ),
                                                                        )}
                                                                    </h5>
                                                                    <InputText
                                                                        id="username"
                                                                        aria-describedby="username-help"
                                                                        className={`${inputTextClassName} `}
                                                                        style={{
                                                                            fontSize:
                                                                                '16px',
                                                                        }}
                                                                        type={
                                                                            childrenItem.type
                                                                        }
                                                                        keyfilter={
                                                                            childrenItem.type ===
                                                                            'password'
                                                                                ? /^[^\s]+$/
                                                                                : /^[^<>*!/^|?,+= ]+$/
                                                                        }
                                                                        value={
                                                                            account[
                                                                                childrenItem
                                                                                    .key
                                                                            ] ||
                                                                            ''
                                                                        }
                                                                        ref={el =>
                                                                            (focusRef.current[
                                                                                idx
                                                                            ] =
                                                                                el)
                                                                        }
                                                                        onKeyPress={event =>
                                                                            handleSignInKeyPress(
                                                                                event,
                                                                                idx,
                                                                            )
                                                                        }
                                                                        onChange={e => {
                                                                            const blackListWhiteSpaceKey =
                                                                                [
                                                                                    loginKeys.username,
                                                                                    loginKeys.usernameOrEmail,
                                                                                ]

                                                                            const normalizedUsername =
                                                                                blackListWhiteSpaceKey.includes(
                                                                                    childrenItem.key,
                                                                                )
                                                                                    ? normalizeUsername(
                                                                                          e
                                                                                              .target
                                                                                              .value,
                                                                                      )
                                                                                    : e
                                                                                          .target
                                                                                          .value

                                                                            setAccount(
                                                                                {
                                                                                    ...account,
                                                                                    [childrenItem.key]:
                                                                                        childrenItem.isLowerCase
                                                                                            ? lowerCase(
                                                                                                  normalizedUsername,
                                                                                              )
                                                                                            : normalizedUsername,
                                                                                },
                                                                            )
                                                                        }}
                                                                        placeholder={translateCommons(
                                                                            childrenItem.placeholder,
                                                                        )}
                                                                    />
                                                                </>
                                                            ) : childrenItem.component ===
                                                              component.checkBoxGroup ? (
                                                                <div className="flex justify-content-between align-items-center ">
                                                                    <div className="flex gap-2 align-items-center">
                                                                        <Checkbox
                                                                            inputId="binary"
                                                                            className="checkbox-login"
                                                                            checked={
                                                                                isRemembered
                                                                            }
                                                                            onChange={() =>
                                                                                handleRememberUser()
                                                                            }
                                                                        />
                                                                        <label htmlFor="binary">
                                                                            <h5 className="mb-0  ">
                                                                                {translateCommons(
                                                                                    'Remember Me',
                                                                                )}
                                                                            </h5>
                                                                        </label>
                                                                    </div>{' '}
                                                                    <div className="flex h-full align-items-center cursor-pointer">
                                                                        {' '}
                                                                        <h5
                                                                            className="m-0 p-0 text-darkcyan font-bold"
                                                                            onClick={() => {
                                                                                setActivePage(
                                                                                    activePageTypes.forgetPassword,
                                                                                )
                                                                            }}>
                                                                            {translateCommons(
                                                                                'Forget Password',
                                                                            )}{' '}
                                                                            ?
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                childrenItem.component ===
                                                                    component.inputMask && (
                                                                    <>
                                                                        <h5 className="my-2 text-700 font-semibold">
                                                                            {translateCommons(
                                                                                childrenItem.label ??
                                                                                    convertKeyToLabel(
                                                                                        childrenItem.key,
                                                                                    ),
                                                                            )}
                                                                        </h5>
                                                                        <InputMask
                                                                            value={
                                                                                account[
                                                                                    childrenItem
                                                                                        .key
                                                                                ] ??
                                                                                ''
                                                                            }
                                                                            className="text-center text-3xl placeholder-text-color w-full input-login font-bold h-4rem uppercase"
                                                                            mask="***-***"
                                                                            placeholder="123-XYZ"
                                                                            onChange={e =>
                                                                                setAccount(
                                                                                    {
                                                                                        ...account,
                                                                                        [childrenItem.key]:
                                                                                            e
                                                                                                .target
                                                                                                .value,
                                                                                    },
                                                                                )
                                                                            }
                                                                        />
                                                                    </>
                                                                )
                                                            )}
                                                        </div>
                                                    ),
                                            )}

                                            {item.key ===
                                                activePageTypes.forgetPassword &&
                                            activeIndex === 1 ? (
                                                <div className="mb-4">
                                                    {resendVerificationTimer ? (
                                                        <div>
                                                            <h4 className="font-semibold text-center mb-3">
                                                                {translateCommons(
                                                                    'Try to resend verification code in',
                                                                )}{' '}
                                                                <span className=" text-darkcyan">
                                                                    {
                                                                        resendVerificationTimer
                                                                    }{' '}
                                                                    {translateCommons(
                                                                        'seconds',
                                                                    )}
                                                                </span>
                                                            </h4>
                                                        </div>
                                                    ) : (
                                                        <h4 className="text-center">
                                                            {translateCommons(
                                                                "Didn't receive the code",
                                                            )}
                                                            ?{' '}
                                                            <span
                                                                style={{
                                                                    color: 'darkcyan',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() =>
                                                                    handleResendVerificationCode()
                                                                }
                                                                className="font-bold">
                                                                {translateCommons(
                                                                    'Resend',
                                                                )}
                                                            </span>
                                                        </h4>
                                                    )}
                                                    <div className="flex justify-content-center align-items-center">
                                                        <h5 className="text-center text-xl mb-0">
                                                            {translateCommons(
                                                                'Note: Please check your mailbox including junk mails',
                                                            )}
                                                        </h5>
                                                    </div>
                                                </div>
                                            ) : (
                                                activeIndex === 3 && (
                                                    <div className="">
                                                        <h6 className="text-center text-2xl">
                                                            {translateCommons(
                                                                'You will be redirected to login page in',
                                                            )}{' '}
                                                            {countDownToLogin}{' '}
                                                            {countDownToLogin &&
                                                            countDownToLogin > 0
                                                                ? translateCommons(
                                                                      'seconds',
                                                                  )
                                                                : ''}
                                                        </h6>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    ),
                            )}
                        </div>

                        <div id="cf-turnstile" className="col-12 px-0">
                            <Turnstile
                                userRef={turnstileRef}
                                sitekey={TURNSTILE}
                                theme="light"
                                retry="auto"
                                refreshExpired="auto"
                                language={getLanguageCode()}
                                size="normal"
                                id="cf-turnstile"
                                fixedSize={true}
                                style={{
                                    width: '500px',
                                }}
                                onVerify={async token => {
                                    if (!!token) {
                                        try {
                                            const responseStatus =
                                                await validateCloudFlareCaptcha(
                                                    token,
                                                )
                                            if (
                                                responseStatus &&
                                                responseStatus ===
                                                    HTTP_STATUS_OK
                                            ) {
                                                setIsHuman(true)
                                            }
                                        } catch (error) {
                                            setIsHuman(true)
                                        }
                                    }
                                }}
                            />
                        </div>
                        <div className="flex flex-column gap-2  py-0 md:py-4">
                            <Button
                                className="col-12 p-button-lg h-4rem border-none font-semibold "
                                icon={
                                    activePage === activePageTypes.login
                                        ? 'pi pi-unlock'
                                        : activePage ===
                                          activePageTypes.forgetPassword
                                        ? 'pi pi-arrow-right'
                                        : activePage ===
                                              activePageTypes.verificationCode &&
                                          'pi pi-send'
                                }
                                label={translateCommons(
                                    activePage === activePageTypes.login
                                        ? 'SIGN IN'
                                        : activePage ===
                                          activePageTypes.forgetPassword
                                        ? activeIndex === 0
                                            ? 'SUBMIT'
                                            : activeIndex === 1
                                            ? 'VERIFY'
                                            : activeIndex === 2
                                            ? 'CHANGE'
                                            : activeIndex === 3 && 'LOGIN NOW'
                                        : 'SUBMIT',
                                )}
                                iconPos={
                                    activePage ===
                                    activePageTypes.forgetPassword
                                        ? 'left'
                                        : 'right'
                                }
                                disabled={!isHuman}
                                onClick={() =>
                                    activePage !== activePageTypes.login
                                        ? onSubmit()
                                        : handleSignIn()
                                }
                            />

                            {/* {activePage === activePageTypes.login && (
                                <>
                                    <div className="flex justify-content-between gap-1 align-items-center w-full py-2">
                                        <div className="flex-grow-1">
                                            <hr className="border-gray-400" />
                                        </div>
                                        <p className="flex-grow-0 m-0 text-base font-bold text-600 ">
                                            {translateCommons('OR')}
                                        </p>
                                        <div className="flex-grow-1">
                                            <hr className="border-gray-400" />
                                        </div>
                                    </div>
                                    <SignInButton />
                                </>
                            )} */}
                            {activePage === activePageTypes.forgetPassword &&
                                ![2, 3].includes(activeIndex) && (
                                    <Button
                                        className="col-12 p-button-lg h-4rem  p-button-text "
                                        label={translateCommons(
                                            activeIndex === 0
                                                ? 'BACK TO LOGIN'
                                                : 'GO BACK',
                                        )}
                                        icon="pi pi-arrow-left"
                                        onClick={() =>
                                            activePage ===
                                            activePageTypes.forgetPassword
                                                ? activeIndex === 0
                                                    ? handleBackToLogin()
                                                    : activeIndex === 1 &&
                                                      toPrevStep()
                                                : {}
                                        }
                                    />
                                )}
                        </div>
                    </div>

                    <div className="flex-none text-lg md:text-xl  lg:text-2xl">
                        <p className="font-bold text-800 p-0 m-0 my-1">
                            {translateCommons(
                                'ThinkVitals SafeStep a vital part of the ThinkShield Caring for Community Ecosystem',
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Authentication)
